import CharityContextProvider from "../../../context/charity/provider";
import PageDetails from "../../general/details";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import CharityContext from "../../../context/charity/context";
import AppContext from "../../../context/app/context";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import {Descriptions as AntdDescriptions} from "antd";
import OldImage from "../../form-components/old-image";
import { getUserStatus, getUserStatusColor } from "../../../models/user/enum";
import Tag from "../../general/antd/tag";

interface Props {
}

const CharityDetails: React.FC<Props> = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id} = useParams();
    const {details, actions, loading} = useContext(CharityContext);
    const {direction} = useContext(AppContext);

    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("charities_manager")}
            buttonName={`${t("update_charity")}`}
            onClick={() => navigate(`/charities/update/${id}`)}
        >
            {loading.includes("details") ? (
                <Spin/>
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("name")}>
                        {details?.name ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("description")}>
                        {details?.description ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("services_provided")}>
                        {details?.servicesProvided ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("name_manager")}>
                        {details?.name_manager ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("phone_manager")}>
                        {details?.phone_manager ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("content")}>
                        {details?.content ?? "-"}
                    </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("status")}>
                            {
                                <Tag
                                    title={getUserStatus(details?.status)}
                                    color={getUserStatusColor(details?.status)}
                                />
                            }
                        </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("hot_line")}>
                        {details?.hot_line ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("address")}>
                        {details?.address ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("mobile")}>
                        {details?.mobile ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("phone")}>
                        {details?.phone ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("serial_number")}>
                        {details?.serial_number ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("telegram")}>
                        {details?.telegram ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("whats_app")}>
                        {details?.whats_app ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("facebook")}>
                        {details?.facebook ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("instagram")}>
                        {details?.instagram ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("establishment_date")}>
                        {details?.establishment_date ? new Date(details.establishment_date).toLocaleDateString() : "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("web_site_link")}>
                        {details?.web_site_link ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("image")}>
                        {details?.image ? (
                            <OldImage preview src={details?.image?.url}/>
                        ) : (
                            "-"
                        )}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("cover")}>
                        {details?.cover ? (
                            <OldImage preview src={details?.cover?.url}/>
                        ) : (
                            "-"
                        )}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("identification_doc")}>
                        {details?.identification_doc ? (
                            <OldImage preview src={details?.identification_doc?.url}/>
                        ) : (
                            "-"
                        )}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("number_of_beneficiaries")}>
                        {details?.number_of_beneficiaries ?? "-"}
                    </AntdDescriptions.Item>
                </Descriptions>
            )}
        </PageDetails>
    )
}

const CharityDetailsPage = () => {
    return (
        <CharityContextProvider>
            <CharityDetails/>
        </CharityContextProvider>
    );
};
export default CharityDetailsPage;